/*
 * Journey step: add Skywalks.
 *
 * Optional. Never blocks continue. The step reports whatever the customer has
 * added, and reports nothing when they have added nothing, which the journey
 * treats as "not settled" so the skip flow (and its exit upsell) can take over.
 *
 * Suggestions are driven by each item's min/max run against the measured run.
 * Suggested items float to the top and carry a badge; nothing is hidden, so a
 * customer can still add anything.
 */
(function () {
  'use strict';

  function Skywalks(root) {
    this.root = root;
    this.config = this.readConfig();
    if (!this.config) return;

    this.stepId = this.config.stepId || 'skywalks';
    this.measureStepId = this.config.measureStepId || 'measure';
    this.labels = this.config.labels || {};
    this.unit = this.config.units === 'm' ? 'm' : 'ft';

    this.introEl = root.querySelector('[data-sky-intro]');
    this.bundlesBlock = root.querySelector('[data-sky-bundles-block]');
    this.bundlesEl = root.querySelector('[data-sky-bundles]');
    this.itemsEl = root.querySelector('[data-sky-items]');
    this.cartEl = root.querySelector('[data-sky-cart]');
    this.countEl = root.querySelector('[data-sky-count]');
    this.totalEl = root.querySelector('[data-sky-total]');

    // handle -> quantity
    this.selected = {};
    this.journey = null;

    this.money = this.moneyFormatter();
    this.bind();
  }

  Skywalks.prototype.readConfig = function () {
    var el = this.root.querySelector('[data-sky-config]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return null;
    }
  };

  Skywalks.prototype.moneyFormatter = function () {
    var currency = this.config.currency || 'USD';
    try {
      // Pinned to the store's locale, not the visitor's. Left as undefined,
      // a visitor browsing from outside the US sees "USD 199.50" where the
      // rest of the storefront says "$199.50", because Intl falls back to a
      // currency code when the locale and currency disagree.
      var fmt = new Intl.NumberFormat(this.config.locale || 'en-US', { style: 'currency', currency: currency });
      return function (cents) {
        return fmt.format(cents / 100);
      };
    } catch (err) {
      return function (cents) {
        return '$' + (cents / 100).toFixed(2);
      };
    }
  };

  Skywalks.prototype.bind = function () {
    var self = this;

    if (window.CatnetsJourney) {
      this.attach(window.CatnetsJourney);
    } else {
      document.addEventListener('journey:ready', function (e) {
        self.attach(e.detail.journey);
      });
    }

    document.addEventListener('journey:step:enter', function (e) {
      if (e.detail.step === self.stepId) self.render();
    });

    document.addEventListener('journey:step:complete', function (e) {
      if (e.detail.step === self.measureStepId) self.render();
    });
  };

  Skywalks.prototype.attach = function (journey) {
    this.journey = journey;

    var saved = journey.data(this.stepId);
    if (saved && saved.selected) this.selected = saved.selected;

    this.render();
  };

  Skywalks.prototype.run = function () {
    var measure = this.journey ? this.journey.data(this.measureStepId) : null;
    if (!measure || !measure.spans) return 0;

    var total = 0;
    for (var i = 0; i < measure.spans.length; i++) total += measure.spans[i].run;
    return total;
  };

  Skywalks.prototype.isSuggested = function (thing, run) {
    var min = thing.suggestMin || 0;
    var max = thing.suggestMax || 0;

    if (!min && !max) return false;
    if (min && run < min) return false;
    if (max && run > max) return false;
    return true;
  };

  Skywalks.prototype.item = function (handle) {
    for (var i = 0; i < this.config.items.length; i++) {
      if (this.config.items[i].handle === handle) return this.config.items[i];
    }
    return null;
  };

  Skywalks.prototype.render = function () {
    if (!this.journey) return;

    var run = this.run();

    if (this.introEl) {
      if (run > 0) {
        this.introEl.textContent = 'Based on your ' + Math.round(run) + this.unit + ' of run, here is what suits.';
        this.introEl.hidden = false;
      } else {
        this.introEl.hidden = true;
      }
    }

    this.renderBundles(run);
    this.renderItems(run);
    this.renderCart();
    this.report();
  };

  Skywalks.prototype.renderBundles = function (run) {
    if (!this.bundlesEl || !this.bundlesBlock) return;

    var bundles = (this.config.bundles || []).filter(function (b) {
      return b.items && b.items.length;
    });

    if (!bundles.length) {
      this.bundlesBlock.hidden = true;
      return;
    }

    var self = this;

    // Block order is authoritative. Only float suggested to the top when the
    // merchant has opted in, so arranging blocks in the theme editor does what
    // they expect. Array.sort is stable, so ties keep their authored order.
    if (this.config.suggestFirst) {
      bundles.sort(function (a, b) {
        return (self.isSuggested(b, run) ? 1 : 0) - (self.isSuggested(a, run) ? 1 : 0);
      });
    }

    this.bundlesBlock.hidden = false;

    var html = '';
    for (var i = 0; i < bundles.length; i++) {
      var bundle = bundles[i];
      var available = bundle.items.filter(function (it) {
        return it.available;
      });
      if (!available.length) continue;

      var total = 0;
      var contents = [];
      for (var c = 0; c < available.length; c++) {
        total += available[c].price;
        contents.push(available[c].title);
      }

      var allIn = this.bundleFullyAdded(available);
      var suggested = this.isSuggested(bundle, run);

      html +=
        '<div class="jsky__bundle' + (allIn ? ' is-added' : '') + '">' +
          (bundle.image ? '<img class="jsky__bundle-image" src="' + bundle.image + '" alt="" loading="lazy">' : '') +
          '<div class="jsky__bundle-body">' +
            (suggested ? '<span class="jsky__badge">' + (this.labels.suggested || 'Suits your space') + '</span>' : '') +
            '<h4 class="jsky__bundle-title">' + bundle.title + '</h4>' +
            (bundle.blurb ? '<p class="jsky__bundle-blurb">' + bundle.blurb + '</p>' : '') +
            '<p class="jsky__bundle-includes"><span>' + (this.labels.bundleItems || 'Includes') + ':</span> ' + contents.join(', ') + '</p>' +
            '<div class="jsky__bundle-foot">' +
              '<span class="jsky__bundle-price">' + this.money(total) + '</span>' +
              '<button type="button" class="jsky__btn' + (allIn ? ' is-added' : '') + '" data-sky-bundle="' + bundle.id + '">' +
                (allIn ? (this.labels.added || 'Added') : (this.labels.addBundle || 'Add this bundle')) +
              '</button>' +
            '</div>' +
          '</div>' +
        '</div>';
    }

    this.bundlesEl.innerHTML = html;

    var buttons = this.bundlesEl.querySelectorAll('[data-sky-bundle]');
    for (var b = 0; b < buttons.length; b++) {
      buttons[b].addEventListener('click', function (e) {
        self.toggleBundle(e.currentTarget.getAttribute('data-sky-bundle'));
      });
    }
  };

  Skywalks.prototype.bundleFullyAdded = function (items) {
    for (var i = 0; i < items.length; i++) {
      if (!this.selected[items[i].handle]) return false;
    }
    return true;
  };

  Skywalks.prototype.toggleBundle = function (id) {
    var bundle = null;
    for (var i = 0; i < this.config.bundles.length; i++) {
      if (this.config.bundles[i].id === id) bundle = this.config.bundles[i];
    }
    if (!bundle) return;

    var available = bundle.items.filter(function (it) {
      return it.available;
    });

    if (this.bundleFullyAdded(available)) {
      for (var r = 0; r < available.length; r++) delete this.selected[available[r].handle];
    } else {
      for (var a = 0; a < available.length; a++) {
        if (!this.selected[available[a].handle]) this.selected[available[a].handle] = 1;
      }
    }

    this.render();
  };

  Skywalks.prototype.renderItems = function (run) {
    if (!this.itemsEl) return;

    var items = (this.config.items || []).slice();
    var self = this;

    // Block order is authoritative. Suggested items are always badged in place;
    // they only jump to the top when the merchant opts in.
    if (this.config.suggestFirst) {
      items.sort(function (a, b) {
        return (self.isSuggested(b, run) ? 1 : 0) - (self.isSuggested(a, run) ? 1 : 0);
      });
    }

    var html = '';
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var qty = this.selected[item.handle] || 0;
      var suggested = this.isSuggested(item, run);
      var soldOut = !item.available;

      html +=
        '<div class="jsky__item' + (qty ? ' is-added' : '') + (soldOut ? ' is-soldout' : '') + '">' +
          (item.image ? '<img class="jsky__item-image" src="' + item.image + '" alt="" loading="lazy">' : '<span class="jsky__item-image"></span>') +
          (suggested ? '<span class="jsky__badge">' + (this.labels.suggested || 'Suits your space') + '</span>' : '') +
          '<div class="jsky__item-body">' +
            '<a class="jsky__item-title" href="' + item.url + '" target="_blank" rel="noopener">' + item.title + '</a>' +
            (item.blurb ? '<p class="jsky__item-blurb">' + item.blurb + '</p>' : '') +
            '<span class="jsky__item-price">' + this.money(item.price) + '</span>' +
          '</div>' +
          '<div class="jsky__item-foot">' +
            (soldOut
              ? '<span class="jsky__soldout">' + (this.labels.soldOut || 'Sold out') + '</span>'
              : (qty
                ? '<div class="jsky__stepper">' +
                    '<button type="button" class="jsky__step" data-sky-dec="' + item.handle + '" aria-label="Remove one">&minus;</button>' +
                    '<span class="jsky__step-qty" data-sky-qty="' + item.handle + '">' + qty + '</span>' +
                    '<button type="button" class="jsky__step" data-sky-inc="' + item.handle + '" aria-label="Add one">+</button>' +
                  '</div>'
                : '<button type="button" class="jsky__btn jsky__btn--add" data-sky-add="' + item.handle + '">' + (this.labels.add || 'Add') + '</button>')
            ) +
          '</div>' +
        '</div>';
    }

    this.itemsEl.innerHTML = html;
    this.bindItemButtons();
  };

  Skywalks.prototype.bindItemButtons = function () {
    var self = this;

    function on(attr, fn) {
      var els = self.itemsEl.querySelectorAll('[' + attr + ']');
      for (var i = 0; i < els.length; i++) {
        els[i].addEventListener('click', function (e) {
          fn(e.currentTarget.getAttribute(attr));
        });
      }
    }

    on('data-sky-add', function (handle) {
      self.selected[handle] = 1;
      self.render();
    });
    on('data-sky-inc', function (handle) {
      self.selected[handle] = (self.selected[handle] || 0) + 1;
      self.render();
    });
    on('data-sky-dec', function (handle) {
      var next = (self.selected[handle] || 0) - 1;
      if (next <= 0) delete self.selected[handle];
      else self.selected[handle] = next;
      self.render();
    });
  };

  Skywalks.prototype.lines = function () {
    var out = [];
    for (var handle in this.selected) {
      var qty = this.selected[handle];
      if (!qty) continue;

      var item = this.item(handle);
      if (!item) continue;

      out.push({
        handle: handle,
        title: item.title,
        variantId: item.variantId,
        sku: item.sku,
        price: item.price,
        quantity: qty,
        total: item.price * qty
      });
    }
    return out;
  };

  Skywalks.prototype.renderCart = function () {
    if (!this.cartEl) return;

    var lines = this.lines();
    if (!lines.length) {
      this.cartEl.hidden = true;
      return;
    }

    var count = 0;
    var total = 0;
    for (var i = 0; i < lines.length; i++) {
      count += lines[i].quantity;
      total += lines[i].total;
    }

    this.cartEl.hidden = false;
    if (this.countEl) this.countEl.textContent = count;
    if (this.totalEl) this.totalEl.textContent = this.money(total);
  };

  Skywalks.prototype.report = function () {
    if (!this.journey) return;

    var lines = this.lines();

    if (!lines.length) {
      // Nothing added. Leave the step unsettled so skip / exit-upsell owns it.
      if (this.journey.data(this.stepId)) this.journey.clear(this.stepId);
      return;
    }

    var total = 0;
    for (var i = 0; i < lines.length; i++) total += lines[i].total;

    this.journey.complete(this.stepId, {
      selected: this.selected,
      items: lines,
      totalPrice: total
    });
  };

  function boot() {
    var roots = document.querySelectorAll('[data-journey-step-source]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].querySelector('[data-sky-config]')) new Skywalks(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
